import { computed } from "@ember/object";
import { classNames } from "@ember-decorators/component";
import DropdownSelectBoxComponent from "discourse/select-kit/components/dropdown-select-box";
import {
  pluginApiIdentifiers,
  selectKitOptions,
} from "discourse/select-kit/components/select-kit";
import { i18n } from "discourse-i18n";

@pluginApiIdentifiers("circles-members-dropdown-bulk-actions")
@selectKitOptions({
  icon: "wrench",
  showFullTitle: false,
})
@classNames("circles-members-dropdown-bulk-actions")
export default class MembersDropdownBulkActions extends DropdownSelectBoxComponent {
  @computed("bulkSelection.[]")
  get content() {
    return [
      {
        id: "removeMembers",
        name: i18n("discourse_circles.circle.members.remove_members"),
        description: i18n(
          "discourse_circles.circle.members.remove_members_description"
        ),
        icon: "user-xmark",
      },
    ];
  }
}
